import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { CerealDropdown, EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { getNumericValidator } from '../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)

function CamposBusqueda (props) {
  const { actualizarFechas, handleSubmit, campoTitular = false, campoCorredor = false, campoCPA = false } = props
  return (
    <Row style={{ display: 'flex', justifyContent: 'center' }}>
      <Col md={3}>
        <DatePicker
          selectRange
          locale='es'
          disabledFuture
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </Col>

      <Col md={3}>
        <EntityAutocomplete
          name='exportador'
          label='Exportador'
          entity='exportador'
          placeholder='Exportador - 19999999991'
          value={''}
        />
      </Col>

      <Col md={3}>
        <CerealDropdown />
      </Col>

      {campoTitular &&
        <Col md={3}>
          <EntityAutocomplete
            name='titularDeCupo'
            label='Titular de cupo'
            entity='cargador'
            placeholder='Titular de cupo - 19999999991'
            value={''}
          />
        </Col>
      }

      {campoCorredor &&
        <Col md={3}>
          <EntityAutocomplete
            name='corredor'
            label='Corredor'
            entity='corredor'
            placeholder='Corredor comprador - 19999999991'
            value={''}
          />
        </Col>
      }

      {campoCPA &&
        <Col md={3}>
          <Field
            name='numero'
            type='text'
            label='Número'
            component={renderTextField}
            autoFocus
            validate={[numeric12]}
            placeholder='10200000000'
          />
        </Col>
      }

      <Col md={2} style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
        <Button
          onClick={handleSubmit}
          variant='contained'
          color='primary'
        >
          Consultar
        </Button>
      </Col>
    </Row>
  )
}

export default CamposBusqueda
